export default {
  name: "Nom",
  tel: "Téléphone",
  save: "sauvegarder",
  confirm: "confirmer",
  cancel: "Annuler",
  delete: "supprimer",
  complete: "Finition",
  loading: "chargement...",
  telEmpty: "Veuillez remplir votre numéro de téléphone",
  nameEmpty: "Veuillez remplir votre nom",
  nameInvalid: "Veuillez saisir un nom valide",
  confirmDelete: "Êtes-vous sûr de vouloir le supprimer",
  telInvalid: "Veuillez saisir le numéro de téléphone correct",
  vanCalendar: {
    end: "Finition",
    start: "commencer",
    title: "titre",
    confirm: "confirmer",
    startEnd: "Commencer la fin",
    weekdays: {
      "0": "jour",
      "1": "un",
      "2": "deux",
      "3": "trois",
      "4": "Quatre",
      "5": "cinq",
      "6": "six"
    }
  },
  vanCascader: { select: "Veuillez sélectionner" },
  vanContactCard: { addText: "Ajouter un contact" },
  vanContactList: { addText: "Nouvelle personne de contact" },
  vanPagination: { prev: "Page précédente", next: "Page suivante" },
  vanPullRefresh: {
    pulling: "Tirez vers le bas pour actualiser ...",
    loosing: "Relâchez-vous à la refrex ..."
  },
  vanSubmitBar: { label: "tous:" },
  vanCoupon: { unlimited: "Aucune restriction d'utilisation" },
  vanCouponCell: { title: "Coupons", tips: "pas disponible" },
  vanCouponList: {
    empty: "Pas de coupons",
    exchange: "échange",
    close: "Pas de coupons",
    enable: "Disponible",
    disabled: "pas disponible",
    placeholder: "Veuillez saisir le code de réduction"
  },
  vanAddressEdit: {
    area: "zone",
    postal: "Code Postal",
    areaEmpty: "Choisissez une région",
    addressEmpty: "Veuillez remplir l'adresse détaillée",
    postalEmpty: "Le format de code postal est incorrect",
    defaultAddress: "Définir comme l'adresse d'expédition par défaut",
    telPlaceholder: "Numéro de mobile du destinataire",
    namePlaceholder: "Nom du destinataire",
    areaPlaceholder: "Sélectionnez une province / ville / district"
  },
  vanAddressEditDetail: {
    label: "adresse",
    placeholder:
      "Numéro de porte de rue, numéro de salle de plancher et autres informations"
  },
  vanAddressList: { add: "Ajouter une adresse" }
};
